import { useEffect, useState } from "react";
import api from "../../utils/api";
import { isStandalone } from "../../pwa/platform";

// Sign in with a 6-digit code sent by email (custom_auth/sign_in_codes.py), shared by the
// student sign-in window (LoginModal) and the staff sign-in page (GuidanceLogin).

export const CODE_LENGTH = 6;
const RESEND_AFTER_SECONDS = 30;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmail = (value) => EMAIL_PATTERN.test(String(value || "").trim());

// portal: "student" or "admin". Resolves to { token, sent_to, expires_in }.
export const requestSignInCode = async (email, portal) => {
  const res = await api.post(
    "/auth/sign-in-code/",
    { email: email.trim(), portal },
    { skipErrorToast: true },
  );
  return res.data;
};

// Resolves to { access, refresh, ... } like /auth/token/.
export const verifySignInCode = async (token, code) => {
  const res = await api.post(
    "/auth/sign-in-code/verify/",
    { token, code, ...(isStandalone() && { installed_app: true }) },
    { skipErrorToast: true },
  );
  return res.data;
};

export const onlyDigits = (value) => String(value || "").replace(/\D/g, "").slice(0, CODE_LENGTH);

export const codeErrorMessage = (err, fallback = "We couldn't check the code. Try again.") => {
  if (!err?.response) return "Can't reach the server. Check your connection and try again.";
  if (err.response.status === 429) return "Too many tries. Wait a few minutes, then try again.";
  return err.response.data?.error || fallback;
};

// Seconds left before "Send again" works; restart() after each send.
export const useResendCountdown = () => {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    if (left <= 0) return undefined;
    const timer = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [left]);
  return [left, () => setLeft(RESEND_AFTER_SECONDS)];
};

export const formatSeconds = (seconds) => `0:${String(Math.max(0, seconds)).padStart(2, "0")}`;
